import * as React from 'react';
import API from "../../common/API";
import { useAuth } from "react-oidc-context";
import { UserLessonDTO, LessonStep, UserCourseDTO, CourseStatus } from "../../common/TrainingTypes";
import Markdown from 'react-markdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import remarkGfm from 'remark-gfm';
import { useTranslation } from 'react-i18next';

export function SoftwareLessonComponent(props: { course: UserCourseDTO, lesson: UserLessonDTO, step: LessonStep, stepDone: (state: boolean) => void }) {
    const auth = useAuth();
    const { t } = useTranslation();

	React.useEffect(() => {
		const parseSteps = (steps: string) => {
			const split = steps.split(";");
			split.forEach((n) => {
				const pieces = n.split(":");
				if (pieces.length !== 2)
					return;
				if (parseInt(pieces[0], 10) === props.step.id) {
					if (pieces[1] === "Complete") {
                        props.stepDone(true);
					}
				}
			});
		}

		const interval = setInterval(async () => {
			const res: StepStatus | null = await API.get("/api/v1/training/courses/" + props.course.id + "/status", auth);
			if (res == null)
				return;

			parseSteps(res.steps);		

		}, 10000);

		parseSteps(props.lesson.stepsComplete);

		return () => clearInterval(interval);
	}, [auth, props.course.id, props.step.id, props.lesson.stepsComplete])

	return (
		<div className="card">
			<div className="card-header">
				<h5 className="card-title mb-0">{props.lesson.name} &bull; {props.step.name}</h5>
			</div>
			<div className="card-body">
				<div className="row">
                    <div className="col-4">
                        <Markdown remarkPlugins={[remarkGfm]}>{props.step.content.replaceAll('\n', '  \n')}</Markdown>
					</div>
                    <div className="col-8 video-responsive">
                        {props.course.status === CourseStatus.InProgress ? <>
						<div className="alert alert-primary alert-outline alert-dismissible" role="alert">
							<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
							<div className="alert-icon"><FontAwesomeIcon icon="key" /></div>
							<div className="alert-message">
                                <strong>{t('training:credentials')} </strong>
                                {t('training:credentialsInfo')} <strong>test@test.com // Training!</strong>
							</div>
						</div>
						<div className="alert alert-danger alert-outline alert-dismissible" role="alert">
							<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
							<div className="alert-icon"><FontAwesomeIcon icon="exclamation-circle" /></div>
							<div className="alert-message">
                                <strong>{t('training:warning')}  </strong>
                                {t('training:deletionWarning')}
							</div>
                        </div>
                            <iframe className="w-100" style={{ aspectRatio: "16/9" }}
                                src={props.course.trainingAddress}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="Software IFrame"
                            /> </> : <></>}
					</div>
				</div>
			</div>
		</div>
	)
}

interface StepStatus {
	userLessonResultId: number,
	steps: string
}